export const TokenCards = [
  {
    title: "Using Tokens",
    description:
      "How to import and use Playbook CSS token exports in React, Sass, and Ruby.",
    icon: "code",
    link: "/tokens/using_tokens",
  },
  {
    title: "Animation",
    description:
      "Predefined duration and easing values for consistent motion effects.",
    icon: "wand-magic-sparkles",
    link: "/tokens/animation",
  },
  {
    title: "Border Radius",
    description:
      "Specific values for corner rounding, from sharp edges to fully rounded.",
    icon: "draw-square",
    link: "/tokens/border_radius",
  },
  {
    title: "Colors",
    description:
      "A set of standardized color values for backgrounds, text, and borders.",
    icon: "palette",
    link: "/tokens/colors",
  },
  {
    title: "Display",
    description:
      "Preset visibility options, such as block, inline, flex, or none.",
    icon: "eye",
    link: "/tokens/display",
  },
  {
    title: "Line Height",
    description:
      "Consistent line-height values to control vertical spacing between text lines.",
    icon: "line-height",
    link: "/tokens/line_height",
  },
  {
    title: "Letter Spacing",
    description:
      "Controls the spacing between characters in text for fine-tuning typographic tone.",
    icon: "letter-spacing",
    link: "/tokens/letter_spacing",
  },
  {
    title: "Opacity",
    description:
      "Defined transparency levels, ranging from 0% (invisible) to 100% (fully visible).",
    icon: "diagram-venn",
    link: "/tokens/opacity",
  },
  {
    title: "Overflow",
    description:
      "Standard options like hidden, scroll, or auto for managing content overflow.",
    icon: "arrow-down-up-across-line",
    link: "/tokens/overflow",
  },
  {
    title: "Position",
    description:
      "Set values for element placement, including static, relative, absolute, or fixed.",
    icon: "arrows-up-down-left-right",
    link: "/tokens/position",
  },
  {
    title: "Scale",
    description:
      "Predefined scaling factors to resize elements proportionally.",
    icon: "arrow-up-right-from-square",
    link: "/tokens/scale",
  },
  {
    title: "Screen Sizes",
    description:
      "Standardized breakpoint values for responsive design across various devices.",
    icon: "laptop-mobile",
    link: "/tokens/screen_sizes",
  },
  {
    title: "Shadow",
    description:
      "Depth and blur values for adding shadow effects, creating depth and emphasis.",
    icon: "shadow",
    link: "/tokens/shadow",
  },
  {
    title: "Spacing",
    description:
      "Preset margin and padding values for consistent spacing across elements.",
    icon: "arrows-from-dotted-line",
    link: "/tokens/spacing",
  },
  {
    title: "Text Align",
    description:
      "Alignment values like left, right, center, and justify for consistent text layout.",
    icon: "align-left",
    link: "/tokens/text_align",
  },
  {
    title: "Titles",
    description:
      "Standardized heading styles with set font sizes and weights for hierarchy.",
    icon: "text-size",
    link: "/tokens/titles",
  },
  {
    title: "Transition",
    description:
      "Predefined timing values for CSS transitions to ensure smooth animations.",
    icon: "wave-sine",
    link: "/tokens/transition",
  },
  {
    title: "Typography",
    description:
      "Set font sizes, weights, and families for consistent text styling.",
    icon: "font",
    link: "/tokens/typography",
  },
  {
    title: "Vertical Align",
    description:
      "Standard values for vertical alignment within containers, like top, middle, or bottom.",
    icon: "objects-align-top",
    link: "/tokens/vertical_align",
  },
  {
    title: "Z-Index",
    description:
      "Adjusts stacking order of elements, controlling which elements appear on top or below others.",
    icon: "bring-front",
    link: "/tokens/z_index",
  },
];
